import {
  Form,
  Button,
  Row,
} from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Field,
  FieldLevelValidationInfo,
  ValidationMessageType,
} from "../../types/field";
import moment from "moment";
import {
  filterNullValues,
  getIndexOfAccessLevel,
  getIndexOfAccessLevelFromVal,
  getIndexOfPlatformAction,
  getIndexOfPlatformActionFromVal
} from "../../utils/utils";
import { AccessLevel, RowLevelAction } from "../../types/types";
import { Notification } from "../notification/notification";
import CustomRecordDetailModal from "../modal/customRecordDetailModal";
import { apiAliasMapper, dataTypeHandling, filterNonCreatableFields, filterNonUpdatableFields, handleLoanNumberLookUp, mapCreateApiToAliasNames, mapViewApiToAliasNames, refreshFieldsBasedOnVisibility, refreshFormulaFields } from "./recordDetailUtils";
import { javascriptRecordDetailFieldLevelHookFns } from "../platformTableComponent/platformTableActionUtils";
import { GetRequest, PostRequest, PutRequest } from "../../utils/api";
import { refineApiWithUrlParams } from "./detailsPageCommonsUtils";
import InputMethods from "./inputFieldRenderMethods";
interface Props {
  urlparams: Map<string, string>;
  recordId: string;
  platformAction: RowLevelAction;
  createApi: string;
  dataApi: string;
  dataApiMapper?: apiAliasMapper[];
  createApiMapper?: apiAliasMapper[];
  viewApi?: string;
  isCreateFlow?: boolean;
  isRelatedInfo?: boolean;
  viewPageBluPrin: any;
  editForm: Field[];
  setOpen: Function;
  dependantFields?: any;
  userAccessLevel: AccessLevel;
  parentEntity?: string;
  recordIds?: any[];
  loanNos?: any[];
  customerNames?: any[];
  refreshTable?: Function;
  allowEdits?: boolean;
  selectedRows?: any[];
  moduleCode: string;
  mulitiDependency?: boolean,
  viewPageBluPrint: any
}

const AssignmentRecordDetails: React.FC<Props> = ({
  recordId,
  editForm,
  dataApi,
  viewApi = dataApi,
  createApi,
  isCreateFlow,
  isRelatedInfo,
  setOpen,
  dependantFields,
  userAccessLevel,
  viewPageBluPrint,
  platformAction,
  parentEntity = undefined,
  urlparams,
  recordIds,
  loanNos,
  customerNames,
  refreshTable = () => { },
  allowEdits,
  selectedRows,
  moduleCode,
  dataApiMapper,
  createApiMapper,
}) => {
  const [formSchema, setFormSchema] = useState<Field[]>([]);

  const [isEditClicked, setIsEditClicked] = useState<boolean>(false);
  const [viewData, setViewData] = useState<any>({});
  const [saveLoading, setSaveLoading] = useState(false);
  const [loading, setLoading] = useState<boolean>(true);


  const resetField = (field: string) => {
    const temp = {
      [field]: undefined
    }
    form.setFieldsValue(temp);
  }

  const setError = (field: string, error: any) => {
    form.setFields([
      {
        name: field, // Field name
        errors: [error.message], // Array of error messages
      }
    ]);
  }

  const [form] = Form.useForm();

  // this doesnt need to take a redux route as its redundant to store in global state.
  const getViewData = async (endpoint: string) => {
    if (endpoint?.length > 0) {

      endpoint = refineApiWithUrlParams(endpoint, urlparams);
      const response = await GetRequest(endpoint);

      const mappedResponse = mapViewApiToAliasNames(response, dataApiMapper);

      console.log(mappedResponse);
      urlparams.forEach((value, key) => {
        mappedResponse[key] = value;
      });

      form.resetFields();
      form.setFieldsValue(dataTypeHandling(mappedResponse, editForm));
      // setViewData(mappedResponse);

      setLoading(false);

    }
  };

  // reconverted to redux as this is dependant on table
  const CreateNewRecord = async (
    endpoint: string,
    recordId: string,
    data: any
  ) => {

    if (endpoint?.length > 0) {
      setSaveLoading(true);
      endpoint = endpoint?.replace("{recordId}", recordId);
      try {

        await PostRequest(endpoint, data, moduleCode);

        Notification("success", "Saved Successfully");
        refreshTable();
        setSaveLoading(false);
        setOpen(false);
      } catch (err: any) {
        setSaveLoading(false);
        if (err?.response?.data && err?.response?.data.errorMessages && err?.response?.data.errorMessages.length > 0) {
          let unknownFieldErrors: string[] = [];
          err?.response?.data.errorMessages.forEach((errorMessage: any) => {
            let errField = errorMessage.field;
            const fieldExists = formSchema.some((x) => x.field === errField && x.display !== false);
            if (fieldExists) {
              setError(errField, {
                type: "focus",
                message: errorMessage.message
              });
            } else {
              unknownFieldErrors.push(errorMessage.message);
            }
          });
          if (unknownFieldErrors.length > 0) {
            Notification("error", unknownFieldErrors.join('\n'));
          }
        } else {
          Notification("error", err?.response?.data?.message ?? "Transaction Failed");
        }
      }
    }
  };

  // reconverted to redux as this is dependant on table
  const UpdateRecord = async (
    endpoint: string,
    recordId: string,
    data: any
  ) => {

    if (endpoint?.length > 0) {
      setSaveLoading(true);
      endpoint = endpoint?.replace("{recordId}", recordId);
      try {

        await PutRequest(endpoint, filterNonUpdatableFields(data, formSchema), moduleCode);

        Notification("success", "Saved Successfully");
        refreshTable();
        setSaveLoading(false);
        setOpen(false);
        setIsEditClicked(false);
      } catch (err: any) {
        setSaveLoading(false);
        if (err?.response?.data && err?.response?.data.errorMessages && err?.response?.data.errorMessages.length > 0) {
          let unknownFieldErrors: string[] = [];
          err?.response?.data.errorMessages.forEach((errorMessage: any) => {
            let errField = errorMessage.field;
            const fieldExists = formSchema.some((x) => x.field === errField && x.display !== false);
            if (fieldExists) {
              setError(errField, {
                type: "focus",
                message: errorMessage.message,
              });
            } else {
              unknownFieldErrors.push(errorMessage.message);
            }
          });
          if (unknownFieldErrors.length > 0) {
            Notification("error", unknownFieldErrors.join('\n'));
          }
        } else {
          Notification("error", err?.response?.data?.message ?? "Transaction Failed");
        }
      }
    }
  };

  const resetFields = () => {
    if (!isCreateFlow) {
      for (const key in form.getFieldsValue()) {
        if (viewData.hasOwnProperty(key)) {
          const value = viewData[key];
          form.setFieldValue(key, value);
          form.setFieldsValue((preVal: any) => ({
            ...preVal,
            [key]: viewData[key] || ""
          }))
        }
        else {
          form.setFieldsValue({
            [key]: ''
          })
          form.setFieldValue(key, "");
        }
      }
    }
    else {
      for (const key in form.getFieldsValue()) {
        if (form.getFieldsValue().hasOwnProperty(key)) {
          form.setFieldValue(key, "");
          form.setFieldsValue({})
        }
      }
      if (recordId === '' && moduleCode == '') {
        const currentDate = moment();
        const formattedDate = currentDate.format('MMM-YY').toLowerCase();
        form.setFieldValue('allocationMthYr', formattedDate);
      }
    }
    getFormSchema();
  }

  const filterReadOnlyFields: any = (data: any) => {
    let editPayload: any = { ...data };
    let readOnlyFields = formSchema
      .filter((x) => !x.editable && x.fieldType !== 'formula')
      .map(({ field }) => field);
    Object.keys(data).forEach((key, index) => {
      if (readOnlyFields.includes(key)) {
        delete editPayload[key];
      }
    });
    return editPayload;
  };

  useEffect(() => {
    if (getIndexOfPlatformAction(platformAction) ===
      getIndexOfPlatformActionFromVal(RowLevelAction.CREATEWITHCONTEXT)) {
      setIsEditClicked(true);
    }
  }, [platformAction]);

  const onSubmit = (data: any) => {

    data = filterNullValues(data);
    // remove readonly fields in case of edit form
    if (!isCreateFlowRequired()) {
      data = filterReadOnlyFields(data);
    } else {
      data = filterNonCreatableFields(data, formSchema);
    }

    data = mapCreateApiToAliasNames(data, viewData, urlparams, createApiMapper);

    let fileChildEntities = formSchema
      .filter(
        (field) => field.childEntity && field.fieldType === "fileUpload"
      )
      .map((f) => {
        return { chilldEntity: f.childEntity, field: f.field };
      });

    fileChildEntities.forEach(({ chilldEntity, field }) => {
      if (!data[chilldEntity!]) {
        data[chilldEntity!] = data[field];
        delete data[field];
      }
    });


    let childEntities = [...formSchema]
      .filter((field) => field.childEntity && field.fieldType !== "fileUpload")
      .map((f) => {
        return { chilldEntity: f.childEntity, field: f.field, iterate: f.iterate ?? false };
      });
    childEntities.forEach(({ chilldEntity, field, iterate }) => {
      
      let childItems: any = [];
      
      if (iterate) {
        let multiValuesData: [] = Array.isArray(data[field]) ? data[field] : data[field]?.split(',');
        multiValuesData?.forEach((value) => {
          let item: any = {};
          item[field] = value;
          childItems.push(item);
        });
      } else {
        let childFormData = data[chilldEntity!]?.[0] ?? {};
        childFormData[field] = data[field];
        childItems.push(childFormData);
      }

      data[chilldEntity!] = [...childItems];
    });

    childEntities.forEach(({ chilldEntity, field }) => {
      delete data[field];
    });

    //this is to pass unique ids as a part of payload
    if (recordIds && recordIds.length > 0) {
      data["recordIds"] = recordIds;
      data["loanNos"] = loanNos;
      data["customerNames"] = customerNames;
    }

    if (parentEntity) {
      let f: any = {};
      f[parentEntity] = [{ ...data }];
      data = f;
    }

    if (isCreateFlowRequired()) {
      CreateNewRecord(createApi, recordId, data);
      // setIsEditClicked(false);
    } else {
      UpdateRecord(dataApi, recordId, data);
    }
  };

  const isCreateFlowRequired = (): boolean => {
    return (
      isCreateFlow ||
      getIndexOfPlatformAction(platformAction) ===
      getIndexOfPlatformActionFromVal(RowLevelAction.TRANSFER) ||
      getIndexOfPlatformAction(platformAction) ===
      getIndexOfPlatformActionFromVal(RowLevelAction.CREATEWITHCONTEXT)
    );
  };

  useEffect(() => {
    if (
      viewApi?.length > 0 &&
      (!isCreateFlow ||
        getIndexOfPlatformAction(platformAction) ===
        getIndexOfPlatformActionFromVal(RowLevelAction.CREATEWITHCONTEXT) ||
        isRelatedInfo)
    ) {
      getViewData(viewApi);
    }
  }, [viewApi, recordId]);

  const filterFormFields = () => {
    return refreshFieldsBasedOnVisibility(editForm, isCreateFlow ?? false, form.getFieldsValue, form.setFieldValue, resetField, formSchema);
  };

  const getFormSchema = useCallback(() => {
    let formFields = filterFormFields();
    setFormSchema(formFields);
  }, [editForm]);

  useEffect(() => {
    getFormSchema();
  }, [editForm]);

  const setInputFieldsValuesObj = () => {
    let tempInputFields: any = {};
    if (formSchema) {
      formSchema?.forEach((item: any) => {
        if (item?.field) {
          tempInputFields[item?.field] = null;
        }
      });
    }
    form.setFieldsValue(tempInputFields);
    if (moduleCode === "systemPis") {
      let totalAmount = 0;
      selectedRows?.forEach((row: any) => {
        totalAmount = totalAmount + row["receiptAmount"];
      });
      form.setFieldValue("totalAmount", totalAmount);
    } else if (moduleCode === "bankPis") {
      let totalAmount = 0;
      selectedRows?.forEach((row: any) => {
        totalAmount = totalAmount + row["spisAmount"];
      });
      form.setFieldValue("depositedAmount", totalAmount);
      form.setFieldValue("toBeDepositedAmount", totalAmount);
      form.setFieldValue("shortAmount", 0);
      form.setFieldValue("excessAmount", 0);

    }
  };

  useEffect(() => {
    if (formSchema) {
      setInputFieldsValuesObj();
    }
  }, [formSchema]);

  const triggerOnChange = (field: Field) => {

    if (field.hooks && field.hooks.length > 0) {
      field.hooks.filter(hook => hook.action === 'onChange' && hook.type === 'javascript')
        .forEach(hook => {

          let methodName: string = hook?.method!;
          let fn = javascriptRecordDetailFieldLevelHookFns.get(methodName);

          if (fn) {
            fn(form.getFieldsValue, field)
              .then((response: FieldLevelValidationInfo | undefined) => {
                if (response) {
                  const type: ValidationMessageType = response.type ?? ValidationMessageType.ERROR;
                  if (type === "ERROR" as ValidationMessageType) {
                    setError(response.field, {
                      type: "focus",
                      message: response.message,
                    });
                  } else if (type === "WARNING" as ValidationMessageType) {

                    form.setFields([{
                      name: field.field,
                      warnings: [response.message]
                    }]);

                  }
                } else {
                  form.setFields([{
                    name: field.field,
                    warnings: []
                  }]);
                }
              });
          }
        });
    }
  };

  const valueStore = useRef<any>();

  useEffect(() => {

    form.setFieldsValue(valueStore.current);
  }, [formSchema]);

  const handleOnChange = (value: any, field: string, isCheckBox: boolean = false) => {

    //Need to store this in ref variable to rerender after formSchema is updated
    const temp = form.getFieldsValue(true)
    temp[field] = value;

    form.setFieldsValue(temp);
    valueStore.current = temp;

    let currentForm = refreshFieldsBasedOnVisibility(editForm, isCreateFlow ?? false, form.getFieldsValue, form.setFieldValue, resetField, formSchema);
    refreshFormulaFields(editForm, form.getFieldsValue, form.setFieldValue, editForm);
    setFormSchema([...currentForm]);
    form.validateFields([field]);

  };

  const handleCascadeOnChange = (value: string, field: string) => {
    // TODO: doesnt work in internet explorer need polyfill
    // api url for cascade fields will be empty handled at client side.
    let indexOfFieldToRefresh = formSchema.findIndex(
      (f: any) => f.valuesDependOnField && f.valuesDependOnField === field
    );

    // fetch field from editform as this has the api urls for the cascade fields
    let fieldData = editForm.find(
      (f: any) => f.valuesDependOnField && f.valuesDependOnField == field
    );

    if (
      indexOfFieldToRefresh === -1 ||
      fieldData === null ||
      fieldData === undefined
    ) {
      return;
    }

    let fieldToRefresh = { ...formSchema[indexOfFieldToRefresh] };

    if (viewData[fieldToRefresh.field] && fieldToRefresh.field !== "calledNumber") {
      delete viewData[fieldToRefresh.field];
    }

    if (urlparams.has(fieldToRefresh.field) && fieldToRefresh.field !== "calledNumber") {
      urlparams.set(fieldToRefresh.field, "");
    }

    // modify api query params based on selection
    let api = fieldData.api;
    let apiWithQueryParams = `${api}&search=${field}:in${value}`;
    fieldToRefresh.api = apiWithQueryParams;

    // update field at certain index
    const newFormSchema = [...formSchema];
    newFormSchema[indexOfFieldToRefresh] = fieldToRefresh;

    setFormSchema(newFormSchema);
    resetField(fieldToRefresh.field);


  };

  const handleOnBlur = async (
    value: any,
    field: string,
    lookupField?: string,
    lookupFieldUrl?: string
  ) => {
    if (!lookupField || !lookupFieldUrl || value === "") {
      return;
    }
    handleLoanNumberLookUp(value, lookupField, lookupFieldUrl)
      .then((customerName) => {
        form.setFieldValue(lookupField, customerName);
        form.setFieldValue(lookupField, customerName);
        // clearErrors(field);
      })
      .catch((error) => {
        setError(field, error);
      });
  };



  const renderActions = () =>
    formSchema?.map((field: Field) => {
      switch (field.fieldType) {
        case "actionButton":
          return field.actionInfo?.type === "modal" ? (
            <CustomRecordDetailModal
              viewPageBluPrint={viewPageBluPrint}
              title={field.actionInfo?.title ?? ""}
              platformAction={field.actionInfo?.launchMode}
              blueprintApi={field.actionInfo?.blueprintApi ?? ""}
              actionName={field.displayName}
              isCreateFlow={field.actionInfo?.launchMode === "Create" || field.actionInfo?.launchMode === "CreateWithContext"}
              userAccessLevel={userAccessLevel}
              moduleCode={moduleCode}
              allowEdits={
                field.actionInfo?.launchMode === "Create" ||
                field.actionInfo?.launchMode === "CreateWithContext" ||
                field.actionInfo?.launchMode === "Edit"
              }
              urlparams={urlparams}
            />
          ) : (
            <></>
          );
      }
    });



  const createEditFields = (): any => {

    if (formSchema) {
      return (
        <>
          {!loading && <>
            <Form form={form} layout="vertical" className="w-100" onFinish={onSubmit}>
              <Row className="mx-auto">
                <InputMethods
                  form={form}
                  handleOnChange={handleOnChange}
                  platformAction={platformAction}
                  isEditClicked={isEditClicked}
                  isCreateFlow={isCreateFlow}
                  editForm={editForm}
                  urlparams={urlparams}
                  handleOnBlur={handleOnBlur}
                  handleCascadeOnChange={handleCascadeOnChange}
                  addGroupFieldBehaviour={null}
                  dependantFields={dependantFields}
                  viewData={viewData}
                  // renderChildForm={renderChildForm}
                  // selectCheckBox={selectCheckBox}
                  formSchema={formSchema}
                  // ref={formFieldsComp}
                  triggerOnChange={triggerOnChange}
                />
              </Row>
              {getIndexOfAccessLevel(userAccessLevel) >
                getIndexOfAccessLevelFromVal(AccessLevel.READ) && allowEdits ? (
                footer()
              ) : (
                <></>
              )}
            </Form>
            <>{renderActions()}</>
          </>}
        </>
      );
    }

  };

  const footer = () =>
    isEditClicked || isCreateFlow ? (
      <div className="text-right mx-3 mt-2">
        <Button className="button-custom-margin" type="primary" htmlType="submit" loading={saveLoading}>
          Save
        </Button>
        {(viewPageBluPrint.resetButton !== true) ? <></> :
          <Button className="button-custom-margin" type="primary" htmlType="button"
            onClick={() => resetFields()}>
            Reset
          </Button>}
        <Button
          className="button-custom-margin"
          type="default"
          hidden={isCreateFlow || getIndexOfPlatformAction(platformAction) ===
            getIndexOfPlatformActionFromVal(RowLevelAction.CREATEWITHCONTEXT)}
          onClick={() => setIsEditClicked(false)}>
          Cancel
        </Button>
      </div>
    ) : (
      <Button type="primary" onClick={() => setIsEditClicked(true)}>
        Edit
      </Button>
    );

  return createEditFields();
};

export default AssignmentRecordDetails;
